import withPagination from '@package/components/Views/withPagination';
/* eslint-disable-next-line import/no-unresolved */
import ListingViewOrig from '@plone/volto-original/components/theme/View/ListingView';

export default withPagination(ListingViewOrig);
